import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "content" }

import { computed, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
  evaluationSampleList,
  evaluationSampleCreate,
  evaluationSampleDelete,
} from "@/common/api/rest/evaluation/sample";

import type { EvaluationType } from "@/common/types/evaluation";
import { SampleType } from "@/common/types/sample";
import { EvaluationSampleType } from "@/common/types/evaluation/sample";

import { searchSample } from "@/components";
import { baseConfirm, baseModal, baseTable } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'samples',
  props: {
    data: {},
    width: { default: "100%" },
    showTitle: { type: Boolean, default: true },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const tableHeader = computed(() => [
  { key: "code", label: t("common.labels.code") },
  { key: "name", label: t("common.labels.name") },
]);

const tableData = ref<EvaluationSampleType[]>([]);
const selected = ref<EvaluationSampleType | null>(null);
const selectedList = ref<SampleType[]>([]);

const limit = ref<number>(5);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showConfirmDel = ref(false);

function fetchData() {
  if (!props.data) return;

  evaluationSampleList(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    limit: limit.value,
    page: page.value,
    search: search.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        tableData.value = data.list;
        page.value = data.infos.page;
        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update() {
  emit("update-data");
}

function add() {
  showModalAdd.value = true;
  selectedList.value = [];
}

function addCancel() {
  showModalAdd.value = false;
  selectedList.value = [];
}

function addSelect(data: SampleType[]) {
  selectedList.value = data;
}

async function addConfirm() {
  if (!props.data || !selectedList.value.length) {
    return;
  }

  showModalAdd.value = false;

  const promises = selectedList.value.map((sl) =>
    evaluationSampleCreate(props.data.account_id, {
      evaluation_id: props.data.evaluation_id,
      sample_id: sl.sample_id,
    }),
  );

  await Promise.all(promises)
    .then((responses) => {
      responses.forEach((response) => {
        const { success, message } = response;
        if (success) {
          toast({ message: message, type: "success" });
          update();
          fetchData();
        } else {
          toast({ message: message, type: "error" });
        }
      });
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function del(data: EvaluationSampleType) {
  selected.value = data;
  showConfirmDel.value = true;
}

function delCancel() {
  selected.value = null;
  showConfirmDel.value = false;
}

function delConfirm() {
  if (!selected.value || !props.data) return;

  showConfirmDel.value = false;

  evaluationSampleDelete(props.data.account_id, selected.value.item_id)
    .then((response) => {
      const { success, message } = response;
      if (success) {
        update();
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function searchItem(value: string) {
  search.value = value;
  fetchData();
}

function changePage(value: number) {
  page.value = value;
  fetchData();
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("common.labels.samples")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(baseTable), {
        header: tableHeader.value,
        data: tableData.value,
        limit: limit.value,
        page: page.value,
        pages: pages.value,
        total: total.value,
        searched: searched.value,
        options: true,
        add: __props.isEdit,
        del: __props.isEdit,
        "onChange:page": _cache[0] || (_cache[0] = ($event: any) => (changePage($event))),
        onSearching: _cache[1] || (_cache[1] = ($event: any) => (searchItem($event))),
        "onBtn:add": _cache[2] || (_cache[2] = ($event: any) => (add())),
        "onBtn:del": _cache[3] || (_cache[3] = ($event: any) => (del($event)))
      }, null, 8, ["header", "data", "limit", "page", "pages", "total", "searched", "add", "del"])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.sample'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (addCancel())),
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(searchSample), {
          status: "AVAILABLE",
          "account-id": __props.data?.account_id,
          ids: tableData.value.map((d) => d.sample_id),
          onUpdateData: addSelect
        }, null, 8, ["account-id", "ids"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showConfirmDel.value,
      "max-width": "400px",
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.sample'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: selected.value?.code,
        })
      ,
      onCancel: delCancel,
      onConfirm: delConfirm
    }, null, 8, ["show", "title", "message"])
  ], 2))
}
}

})